const SENTENCE_ENDINGS = /[.!?]+(?=\s|$)/g;

const STOPWORDS = new Set([
  "a",
  "an",
  "and",
  "are",
  "as",
  "at",
  "be",
  "by",
  "for",
  "from",
  "has",
  "he",
  "in",
  "is",
  "it",
  "its",
  "of",
  "on",
  "that",
  "the",
  "to",
  "was",
  "will",
  "with",
  "or",
  "but",
  "not",
  "this",
  "they",
  "their",
  "what",
  "which",
  "who",
  "when",
  "where",
  "how",
  "why",
  "can",
  "could",
  "would",
  "should",
  "may",
  "might",
]);

export const smartTruncate = (text: string, maxChars = 350): string => {
  if (text.length <= maxChars) {
    return text;
  }

  const minAcceptableLength = Math.floor(maxChars * 0.7);
  const searchText = text.substring(0, maxChars);

  let lastSentenceEnd = -1;

  SENTENCE_ENDINGS.lastIndex = 0;
  let match = SENTENCE_ENDINGS.exec(searchText);
  while (match !== null) {
    lastSentenceEnd = match.index + match[0].length;
    match = SENTENCE_ENDINGS.exec(searchText);
  }

  if (lastSentenceEnd >= minAcceptableLength) {
    return text.substring(0, lastSentenceEnd).trim();
  }

  return `${text.substring(0, maxChars).trim()}...`;
};

export const extractQueryTerms = (query: string): string[] => {
  const words = query
    .toLowerCase()
    .split(/\s+/)
    .filter((word) => word.length > 2 && !STOPWORDS.has(word));

  return [...new Set(words)];
};

export const highlightQueryTerms = (text: string, queryTerms: string[]): string => {
  if (queryTerms.length === 0) {
    return text;
  }

  const pattern = queryTerms.map((term) => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");

  const regex = new RegExp(`\\b(${pattern})\\b`, "gi");

  return text.replace(regex, '<mark class="bg-yellow-200 dark:bg-yellow-800/50 px-0.5 rounded">$1</mark>');
};

export const extractMarkdownText = (markdown: string): string => {
  return (
    markdown
      // Remove heading markers
      .replace(/^#{1,6}\s+/gm, "")
      // Remove bold and italic markers
      .replace(/(\*\*|__)(.*?)\1/g, "$2")
      .replace(/(\*|_)(.*?)\1/g, "$2")
      // Remove inline code backticks
      .replace(/`([^`]+)`/g, "$1")
      // Extract link text only
      .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
      // Remove image syntax
      .replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1")
      .trim()
  );
};
